import { render } from "./productive_vs_non_productive_logs.vue?vue&type=template&id=412c597d&scoped=true"
import script from "./productive_vs_non_productive_logs.vue?vue&type=script&lang=js"
export * from "./productive_vs_non_productive_logs.vue?vue&type=script&lang=js"

import "./productive_vs_non_productive_logs.vue?vue&type=style&index=0&id=412c597d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412c597d"]])

export default __exports__